import * as React from 'react'
import { createIcon } from './createIcon'
import { IconOptions } from './icon-options'

function IconContent({ color }: IconOptions) {
  return (
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M11.9998 6.99852C14.7598 6.99852 16.9998 9.23852 16.9998 11.9985C16.9998 12.6485 16.8698 13.2585 16.6398 13.8285L19.5598 16.7485C21.0698 15.4885 22.2598 13.8585 22.9898 11.9985C21.2598 7.60852 16.9898 4.49852 11.9898 4.49852C10.5898 4.49852 9.24977 4.74852 8.00977 5.19852L10.1698 7.35852C10.7398 7.12852 11.3498 6.99852 11.9998 6.99852ZM2 4.26902L4.28 6.54902L4.74 7.00902C3.08 8.29902 1.78 10.019 1 11.999C2.73 16.389 7 19.499 12 19.499C13.55 19.499 15.03 19.199 16.38 18.659L16.8 19.079L19.73 21.999L21 20.729L3.27 2.99902L2 4.26902ZM7.53 9.79895L9.08 11.3489C9.03 11.5589 9 11.7789 9 11.9989C9 13.6589 10.34 14.9989 12 14.9989C12.22 14.9989 12.44 14.9689 12.65 14.9189L14.2 16.4689C13.53 16.7989 12.79 16.9989 12 16.9989C9.24 16.9989 7 14.7589 7 11.9989C7 11.2089 7.2 10.4689 7.53 9.79895ZM11.8398 9.01811L14.9898 12.1681L15.0098 12.0081C15.0098 10.3481 13.6698 9.00811 12.0098 9.00811L11.8398 9.01811Z'
      fill={color}
    />
  )
}

export const EyeHiddenIcon = createIcon(IconContent)
